import { render, staticRenderFns } from "./view-following-up-phone.vue?vue&type=template&id=104703e7&scoped=true&"
import script from "./view-following-up-phone.vue?vue&type=script&lang=js&"
export * from "./view-following-up-phone.vue?vue&type=script&lang=js&"
import style0 from "./view-following-up-phone.vue?vue&type=style&index=0&id=104703e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104703e7",
  null
  
)

export default component.exports